// extracted by mini-css-extract-plugin
module.exports = {"templatesList":"ChessByFileModal_templatesList__2sXwK"};